export const isUndefinedOrEmpty = (input) => {
  return (input ?? '').trim().length === 0;
};
